import React, { useEffect, useState } from "react";
import { getRequest } from "../../globalhelper/helper";
import { CSVLink } from "react-csv";
import GetAppIcon from "@material-ui/icons/GetApp";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import LastPageIcon from "@mui/icons-material/LastPage";
import PropTypes from "prop-types";
import { Accordion, AccordionDetails, AccordionSummary, Alert, AlertTitle, Autocomplete, Box, Button, Grid, IconButton, Pagination, Paper, Table, TableBody, TableCell, TableContainer, TableFooter, TableHead, TablePagination, TableRow, TextField, Typography, useTheme } from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { useDispatch } from "react-redux";
import { hideLoader, showLoader } from "../../redux/Common/commonActions";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import moment from "moment";
import { KeyboardArrowLeft, KeyboardArrowRight } from "@material-ui/icons";
function TablePaginationActions(props) {
  const theme = useTheme();
  const {
    count,
    page,
    rowsPerPage,
    onPageChange
  } = props;
  const [previousCount, setPreviousCount] = useState(count);
  useEffect(() => {
    if (count !== previousCount && page !== 0) {
      onPageChange(null, 0);
    }
    setPreviousCount(count);
  }, [count, page, onPageChange, previousCount]);
  const handleFirstPageButtonClick = event => {
    onPageChange(event, 0);
  };
  const handleBackButtonClick = event => {
    onPageChange(event, page - 1);
  };
  const handleNextButtonClick = event => {
    onPageChange(event, page + 1);
  };
  const handleLastPageButtonClick = event => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };
  return <Box sx={{
    flexShrink: 0,
    ml: 2.5
  }}>
      <IconButton onClick={handleFirstPageButtonClick} disabled={page === 0} aria-label="first page">
        {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton onClick={handleBackButtonClick} disabled={page === 0} aria-label="previous page">
        {theme.direction === "rtl" ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
      </IconButton>
      <IconButton onClick={handleNextButtonClick} disabled={page >= Math.ceil(count / rowsPerPage) - 1} aria-label="next page">
        {theme.direction === "rtl" ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
      </IconButton>
      <IconButton onClick={handleLastPageButtonClick} disabled={page >= Math.ceil(count / rowsPerPage) - 1} aria-label="last page">
        {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </Box>;
}
TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired
};
const ItemListReport = () => {
  const [tableData, setTableData] = useState([]);
  const [companyName, setCompanyName] = useState([]);
  const [companyDetails, setCompanyDetails] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [itemname, setItemname] = useState("");
  const [itemid, setItemid] = useState("");
  const [status, setStatus] = useState("");
  const [ItemNames, setItemnames] = useState([]);
  const [ItemIDs, setItemIDs] = useState([]);
  const [ApprovalStatus, setApprovalStatus] = useState([]);
  let dispatch = useDispatch();
  let [message, setMessage] = useState(null);
  const [formData, setFormData] = useState({
    company: "",
    fromDate: "",
    toDate: ""
  });
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  // Avoid a layout jump when reaching the last page with empty filteredData.
  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - tableData.length) : 0;
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = event => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  useEffect(() => {
    getRequest(`api/edureka/getCompanyAssignedToUser`).then(response => {
      const responseData = response.res.data;
      const orgname = responseData.map(item => item.orgname);
      setCompanyDetails(responseData);
      setCompanyName(orgname);
      if (orgname.length === 1) {
        handleChange("company", orgname[0]);
      }
    });
    var currentDate = moment();
    var firstDay = currentDate.startOf("month").format("YYYY-MM-DD");
    var lastDay = currentDate.endOf("month").format("YYYY-MM-DD");
    setFormData(prev => {
      return {
        ...prev,
        fromDate: firstDay,
        toDate: lastDay
      };
    });
  }, []);
  const handleChange = (name, value) => {
    setFormData(prev => {
      return {
        ...prev,
        [name]: value
      };
    });
  };
  const handleReset = () => {
    setFormData({
      fromDate: "",
      toDate: "",
      company: ""
    });
    setTableData([]);
    setFilteredData([]);
    setItemnames([]);
    setItemIDs([]);
    setApprovalStatus([]);
    setItemname("");
    setItemid("");
    setStatus("");
  };
  const handleSubmit = () => {
    const {
      fromDate,
      toDate,
      company
    } = formData;
    if (fromDate && toDate && company) {
      const id = companyDetails.filter(item => item.orgname === company);
      dispatch(showLoader());
      const companyid = id.map(item => item.orgid);
      getRequest(`api/edureka/getItemListForReport?fromDate=${fromDate}&toDate=${toDate}&company=${companyid[0]}`).then(response => {
        const responseData = JSON.parse(response.res.data);
        if (response.res.status === "success") {
          if (responseData.length === 0) {
            setMessage(<Box sx={{
              margin: "auto"
            }}>
                  <Alert severity="warning">
                    <AlertTitle>No Data Found</AlertTitle>
                    There is no data to display at the moment.
                  </Alert>
                </Box>);
            return;
          } else {
            setMessage(null);
          }
          setTableData(responseData);
          setFilteredData(responseData);
          setApprovalStatus(Array.from(new Set(responseData.map(item => item.approvalstatustext))).sort());
          setItemnames(Array.from(new Set(responseData.map(item => item.itemname))).sort());
          setItemIDs(Array.from(new Set(responseData.map(item => item.itemid))).sort());
        } else {
          <Box sx={{
            margin: "auto"
          }}>
              <Alert severity="error">
                <AlertTitle>No Data Found</AlertTitle>
                Problem With Connecting Server.
              </Alert>
            </Box>;
        }
      }).catch(err => {
        console.log(err);
      }).finally(() => dispatch(hideLoader()));
    }
  };
  useEffect(() => {
    if (itemname === "" && itemid === "" && status === "" || !itemname && !itemid && !status) {
      setFilteredData(tableData);
    } else {
      handleFilterChange(itemname, itemid, status);
    }
  }, [itemname, itemid, status]);
  const handleFilterChange = (itemname, itemid, status) => {
    let filteredData = tableData.filter(data => data.itemname === itemname || data.approvalstatustext === status || data.itemid === itemid);
    setFilteredData(filteredData);
  };
  return <>
      <Accordion defaultExpanded>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography variant="h6">Search Report</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Grid container gap={2} spacing={3}>
            <Grid item xl={3}>
              <Autocomplete options={companyName || []} value={formData.company} onChange={(e, newValue) => handleChange("company", newValue)} fullWidth renderInput={params => <TextField {...params} label="Organization Name" variant="outlined" size="small" />} />
            </Grid>

            <Grid item xl={2}>
              <LocalizationProvider dateAdapter={AdapterMoment}>
                <DatePicker label="ForPrdFrom" value={formData.fromDate} views={["day", "month", "year"]} onChange={newValue => {
                handleChange("fromDate", newValue.format("YYYY-MM-DD"));
              }} renderInput={params => <TextField fullWidth size="small" {...params} />} />
              </LocalizationProvider>
            </Grid>

            <Grid item xl={2}>
              <LocalizationProvider dateAdapter={AdapterMoment}>
                <DatePicker label="ForPrdTo" value={formData.toDate} views={["day", "month", "year"]} onChange={newValue => {
                handleChange("toDate", newValue.format("YYYY-MM-DD"));
              }} renderInput={params => <TextField fullWidth size="small" {...params} />} />
              </LocalizationProvider>
            </Grid>
            <Grid item xl={1}>
              <Button color="primary" variant="contained" onClick={handleSubmit}>
                Submit
              </Button>
            </Grid>
            <Grid item xl={1}>
              <Button color="error" variant="contained" onClick={handleReset}>
                Reset
              </Button>
            </Grid>
            {tableData.length > 0 && <>
                <Grid item xs={12}>
                  <Typography variant="h6">
                    Filter Report
                  </Typography>
                </Grid>
                <Grid item xl={3}>
                  <Autocomplete options={ItemNames || []} value={itemname || null} onChange={(e, newValue) => {
                setPage(0);
                setItemname(newValue);
                setStatus("");
                setItemid("");
              }} fullWidth renderInput={params => <TextField {...params} label="Filter Item Name" variant="outlined" size="small" />} />
                </Grid>
                <Grid item xl={3}>
                  <Autocomplete options={ItemIDs || []} value={itemid || null} onChange={(e, newValue) => {
                setPage(0);
                setItemname("");
                setStatus("");
                setItemid(newValue);
              }} fullWidth renderInput={params => <TextField {...params} label="Filter Item ID" variant="outlined" size="small" />} />
                </Grid>
                <Grid item xl={3}>
                  <Autocomplete options={ApprovalStatus || []} value={status || null} onChange={(e, newValue) => {
                setPage(0);
                setItemname("");
                setStatus(newValue);
                setItemid("");
              }} fullWidth renderInput={params => <TextField {...params} label="Filter Approval Status" variant="outlined" size="small" />} />
                </Grid>
              </>}
          </Grid>
        </AccordionDetails>
      </Accordion>

      {filteredData.length ? <>
          <Box align="right" sx={{
        m: 2,
        display: "flex",
        justifyContent: "flex-end",
        flexDirection: "row",
        gap: 2
      }}>
            <Pagination count={Math.ceil(filteredData.length / rowsPerPage)} page={page + 1} onChange={(event, newPage) => {
          handleChangePage(event, newPage - 1);
        }} variant="outlined" shape="rounded" showFirstButton showLastButton />
            &nbsp;
            <CSVLink size="sm" filename={`VendorListReport_${moment().format("YYYY-MM-DD_HH-mm-ss")}.csv`} data={tableData}>
              <Button variant="contained" color="success">
                <GetAppIcon />
              </Button>
            </CSVLink>
          </Box>
          <TableContainer component={Paper}>
            <Table sx={{
          minWidth: 650
        }} aria-label="simple table">
              <TableHead>
                <TableRow>
                  {((rowsPerPage > 0 ? filteredData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage) : filteredData) && (rowsPerPage > 0 ? filteredData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage) : filteredData).length > 0 ? Object.keys((rowsPerPage > 0 ? filteredData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage) : filteredData)[0] || {}) : []).map((key, index) => <TableCell key={index} sx={{
                textAlign: 'left'
              }}><b>{key}</b></TableCell>)}
                </TableRow>
              </TableHead>
              <TableBody>
                {((rowsPerPage > 0 ? filteredData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage) : filteredData) || []).map((row, rowIndex) => <TableRow key={rowIndex}>
                    {Object.entries(row || {}).map(([key, val], valIndex) => {
                let displayVal = val;
                if (typeof val === 'number' && !Number.isInteger(val)) {
                  displayVal = val.toFixed(2);
                } else if (typeof val === 'string' && !isNaN(val) && val.trim() !== '' && val.includes('.')) {
                  displayVal = parseFloat(val).toFixed(2);
                } else if (typeof val === 'boolean') {
                  displayVal = val ? 'Yes' : 'No';
                } else if (val === null || val === undefined) {
                  displayVal = '';
                } else if (typeof val === 'object') {
                  displayVal = JSON.stringify(val);
                }
                return <TableCell key={valIndex} sx={{
                  textAlign: 'left'
                }}>
                          {String(displayVal)}
                        </TableCell>;
              })}
                  </TableRow>)}
              </TableBody>
            </Table>
          </TableContainer>
        </> : null}
      {message}
    </>;
};
export default ItemListReport;